<div class="leader-board" (mousedown)="onMouseDown()" (mouseup)="onMouseUp()" *ngIf="!resetBoard">
  <div [ngClass]="{'match-data-container': game.kind == 'match', 'trivia-data-container': game.kind == 'trivia'}">
    <img src="./assets/images/icons/award.png">
    <h2 id="champ">{{champion.name}}</h2>
  </div>
  <div [ngClass]="{'match-data-container': game.kind == 'match', 'trivia-data-container': game.kind == 'trivia'}">
    <img src="./assets/images/icons/money.png">
    <h2>{{champion.score}}</h2>
  </div>
  <div [ngClass]="{'match-data-container': game.kind == 'match', 'trivia-data-container': game.kind == 'trivia'}" routerLink="/leader-board-list">
    <div class="white-circle list-circle">
      <!-- <img src="./assets/images/icons/list.png"> -->
    </div>
    <div id="full-list" role="button">לרשימה המלאה</div>
  </div>
</div>
<div *ngIf="resetBoard">
  <input type="password" [(ngModel)]="pass">
  <button (click)="onResetBoard()">איפוס טבלת אלופים</button>
</div>
